export default function () {
  const { localizedStrings } = useLocalizedStrings()
  const ls = localizedStrings.value
  return [
    ls['dotwa-sun'],
    ls['dotwa-mon'],
    ls['dotwa-tue'],
    ls['dotwa-wed'],
    ls['dotwa-thu'],
    ls['dotwa-fri'],
    ls['dotwa-sat'],
  ]
}
